import { Component, OnInit } from '@angular/core';
import { SharedHeader } from '../../shared/legal-system.model';
import { Observable } from 'rxjs';
import { LegalSystemsService } from '../../services/legal-systems.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {

  header$!: Observable<SharedHeader>

  constructor (private legal: LegalSystemsService) {}

  ngOnInit(): void {
    this.header$ = this.legal.getSharedHeader('header')
  }

}
